/* eslint-disable react/prop-types */
import React from 'react';
import { ReactComponent as InfoFillSvg } from 'assets/icons/New/InfoFill.svg';
import { ATooltip } from 'components/Antd';
import cn from 'classnames';
import classes from './ExpiredIcon.module.scss';

const ExpiredIcon = ({ className }) => {
  return (
    <ATooltip title="Data Expired" dark>
      <span className={cn(classes.wrapper, className)}>
        <InfoFillSvg />
      </span>
    </ATooltip>
  );
};

export default ExpiredIcon;
